import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { inviteInhabitant } from '../../../api'
import { EMPTY_OBJECT } from '../../../constants/common'
import { useInlineNotifications, useUk } from '../../../hooks'
import { brToNewLine } from '../../../utils/common'
import { clearEmptyFields } from '../../../utils/formHelpers'
import { FormikForm } from '../../Formik'

import {
  getInhabitantFormCreationPayload,
  getInhabitantFormInitialValues,
  getInhabitantFormValidationSchema,
  parseInhabitantFormServerError,
} from './InhabitantForm.utils'
import { InhabitantFormFields } from './InhabitantFormFields'

function InhabitantForm({
  FormContainer,
  containerProps,
  getInitialValues = getInhabitantFormInitialValues,
  setModal,
  onCancel,
  onError,
  onSuccess,
  ...restProps
}) {
  const { t } = useTranslation()

  const ukData = useUk()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getInhabitantFormValidationSchema()

  const initialValues = getInitialValues({
    message: brToNewLine(ukData.config.invitation_text_for_dwellers),
    subject: ukData.config.invitation_subject_for_dwellers,
    t,
  })

  function handleSubmit(values, { setErrors, setSubmitting }) {
    setErrors(EMPTY_OBJECT)

    const payload = getInhabitantFormCreationPayload(values)

    inviteInhabitant({ data: clearEmptyFields(payload) })
      .then(({ data }) => {
        onSuccess?.({
          data,
          isFlatCreated:
            !Number.isSafeInteger(values.flat.value) && values.flat,
        })
      })
      .catch(({ response }) => {
        if (isEmpty(response?.data)) {
          onError?.()
        } else {
          setSubmitting(false)
          setErrors(parseInhabitantFormServerError(response?.data))
        }
      })
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <InhabitantFormFields
        {...restProps}
        notifications={notifications}
        setModal={setModal}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default InhabitantForm
